export default "__VITE_ASSET__XlfIt8GK__"